import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import VueEnv from './lib/env'
import VueLang from './lib/lang'
import VueDate from './lib/date'


Vue.use(VueEnv)
Vue.use(VueLang)
Vue.use(VueDate)

Vue.config.productionTip = (process.env.NODE_ENV === 'development')

export const EventBus = new Vue()

new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app')
